<template>
    <div class="container h-full">
        <div v-if="discontinued" class="bg-red text-white text-sm text-thin rounded h-6 w-full flex items-center justify-center">{{discontinued}}</div>
        <ul v-else-if="currentStep < length || !successMessage" class="progressbar list-reset h-6">
          <li :class="{'active': i <= currentStep}" v-for="i in length" :key="i"> </li>
        </ul>
        <div v-else-if="successMessage" class="bg-green text-white text-sm text-thin rounded h-6 px-4 w-32 flex items-center justify-center">{{successMessage}}</div>
    </div>
</template>
<script>
export default {
  props: {
    length: {
      type: Number,
      default () {
        return 0
      },
    },
    discontinued: {
      type: String,
      default () {
        return ''
      },
    },
    currentStep: {
      type: Number,
      default () {
        return 0
      },
    },
    successMessage: {
      type: String,
      default () {
        return ''
      },
    },
  },
}
</script>

<style scoped>
.container{
  position: relative;
  z-index: 1;
}
.progressbar{
  counter-reset: step;
}
.progressbar li{
  float: left;
  width: 26px;
  position: relative;
  text-align: center;
}
.progressbar li:before{
  content:counter(step);
  counter-increment: step;
  width: 20px;
  height: 20px;
  border: 2px solid #38c172;
  margin: 0 auto 0px auto;
  border-radius: 50%;
  line-height: 27px;
  background: white;
  color: #38c172;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding-top: 2px; */
  font-size: 12px;
  /* font-weight: bold; */
}
.progressbar li:after{
  content: '';
  position: absolute;
  width:100%;
  height: 3px;
  background: #38c172;
  top: 10px;
  left: -50%;
  z-index: -1;
}
.progressbar li.active:before{
 border-color: #38c172;
 background: #38c172;
 color: white
}
.progressbar li.active:after{
 background: #38c172;
}
.progressbar li.active - li:after{
 background: #38c172;
}
.progressbar li.active - li:before{
border-color: #38c172;
background: #38c172;
color: white
}
.progressbar li:first-child:after{
 content: none;
}
</style>



// WEBPACK FOOTER //
// src/components/TableComponents/CompletedSteps.vue